import { Warning } from "./Warning";

export const Icon = {
    Warning
}